import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import SecondLayout from "../../../layouts/SecondLayout";
import FAQSection from "./FAQSection";
import BusinessOpportunityCard from "./BusinessOpportunityCard";

const BusinessOtherCountries = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    window.scrollTo(0, 0);
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => (prev !== currentLang ? currentLang : prev));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const pageTitle =
    language === "ar" ? "" : "The Sky is not the Limit, Your Mind Is.";
  const translations = {
    en: {
      heading1: "UK,USA, Europe and other countries",
      text1:
        "UK,USA, Europe and other countries If you love beauty and skincare products like me, and want to create a new experience for you or around your busy life this is a perfect match.",
      text2:
        "It will be your own skincare and beauty business that you can do online, offline or both. Be part of this amazing journey and build something to call your own.",
      text3:
        "As a Mom, Nuskin has give me the power to be in charge of my business, in charge of my life, and it can do so for you too.",
      text4: "Get in touch with me, and let’s get you started.",
    },
    ar: {
      heading1: "المملكة المتحدة، أمريكا، أوروبا ودول أخرى",
      text1:
        "إذا كنتِ من محبّات منتجات التجميل والعناية بالبشرة مثلي، وترغبين في خلق تجربة جديدة لنفسك أو ضمن نمط حياتك المزدحم، فهذا الخيار مثالي لك.",
      text2:
        "سيكون لديك مشروعك الخاص في مجال العناية بالبشرة والجمال، يمكنك العمل به عبر الإنترنت أو خارجه أو كلاهما. كوني جزءًا من هذه الرحلة الرائعة وابدئي ببناء شيء تفتخرين به.",
      text3:
        "بصفتي أمًّا، منحتني شركة Nuskin القدرة على التحكم في عملي وفي حياتي، ويمكنها أن تمنحكِ نفس القوة أيضًا.",
      text4: "تواصلي معي ودعينا نبدأ معًا.",
    },
  };

  const t = translations[language];
  const isArabic = language === "ar";
  return (
    <SecondLayout>
      <div className="container">
        <h2 className="about-me-title">{pageTitle}</h2>
      </div>

      <div className="opportunity-section">
        <div className={`opportunity-row ${isArabic ? "reverse" : ""}`}>
          <div className="opportunity-img">
            <img src="/assets/images/Business/Business-3.jpeg" alt="MENA" />
          </div>
          <div className="opportunity-business-text light-bg">
            <h3>{t.heading1}</h3>
            <p>{t.text1}</p>
            <p>{t.text2}</p>
            <p>{t.text3}</p>
            <p>{t.text4}</p>
          </div>
        </div>
      </div>
      <FAQSection language={language} />
      <BusinessOpportunityCard language={language}/>
    </SecondLayout>
  );
};

export default BusinessOtherCountries;
